import type { RouteObject } from "react-router-dom";
import { Navigate, createBrowserRouter } from "react-router-dom";

import { AppLayout } from "~/components/layout";
import { ProtectedRoute } from "~/features/auth/components";
import { LoginPage } from "~/features/auth/pages/login-page";
import { HomePage } from "~/features/home/pages/home-page";
import { surveyDetailRoutes } from "~/features/surveys/lib/survey-detail-routes";
import { SurveyDetailLayout } from "~/features/surveys/pages/survey-detail-layout";
import { SurveyDetailSectionPage } from "~/features/surveys/pages/survey-detail-section-page";
import { SurveyListPage } from "~/features/surveys/pages/survey-list-page";
import { SurveyReportRouteFallback } from "~/features/surveys/pages/survey-report-page/survey-report-route-fallback";
import { SurveySiteRouteFallback } from "~/features/surveys/pages/survey-site-page/survey-site-route-fallback";

export const appRoutes: RouteObject[] = [
  { path: "/login", element: <LoginPage /> },
  {
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <HomePage /> },
      { path: "surveys", element: <SurveyListPage /> },
      {
        path: "surveys/:uuid",
        element: <SurveyDetailLayout />,
        children: [
          {
            index: true,
            element: <Navigate to={surveyDetailRoutes.site.path} replace />,
          },
          {
            path: surveyDetailRoutes.site.path,
            hydrateFallbackElement: <SurveySiteRouteFallback />,
            lazy: () =>
              import(
                "~/features/surveys/pages/survey-site-page/survey-site-route"
              ),
          },
          {
            path: surveyDetailRoutes.anomalies.path,
            element: <SurveyDetailSectionPage />,
          },
          {
            path: surveyDetailRoutes.obstacles.path,
            element: <SurveyDetailSectionPage />,
          },
          {
            path: surveyDetailRoutes.report.path,
            hydrateFallbackElement: <SurveyReportRouteFallback />,
            lazy: () =>
              import(
                "~/features/surveys/pages/survey-report-page/survey-report-route"
              ),
          },
        ],
      },
    ],
  },
];

export const router = createBrowserRouter(appRoutes);
